/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Footer_Verbis_Logo_AltInputs */

const tr_legal_footer_verbis_logo_alt = /** @type {(inputs: Legal_Footer_Verbis_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK Veri Sorumlusu Sicili - Başvuru aşamasında`)
};

const en_legal_footer_verbis_logo_alt = /** @type {(inputs: Legal_Footer_Verbis_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK data controllers registry: application submitted`)
};

const de_legal_footer_verbis_logo_alt = /** @type {(inputs: Legal_Footer_Verbis_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK-Register der Verantwortlichen: Antrag eingereicht`)
};

const ru_legal_footer_verbis_logo_alt = /** @type {(inputs: Legal_Footer_Verbis_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Реестр операторов данных KVKK: заявление подано`)
};

/**
* | output |
* | --- |
* | "KVKK data controllers registry: application submitted" |
*
* @param {Legal_Footer_Verbis_Logo_AltInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const legal_footer_verbis_logo_alt = /** @type {((inputs?: Legal_Footer_Verbis_Logo_AltInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Footer_Verbis_Logo_AltInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_footer_verbis_logo_alt(inputs)
	if (locale === "de") return de_legal_footer_verbis_logo_alt(inputs)
	if (locale === "ru") return ru_legal_footer_verbis_logo_alt(inputs)
	return tr_legal_footer_verbis_logo_alt(inputs)
});